// Must stay in sync with the server's multer limit (UrlJobsController) and below
// the ingress proxy-body-size (services/internal-service/.k8s/overlays/*/ingress.yaml).
export const MAX_UPLOAD_BYTES = 5 * 1024 * 1024;

export const MAX_BULK_DELETE_ROWS = 35_000;

export const formatUploadLimit = (): string => `${MAX_UPLOAD_BYTES / (1024 * 1024)} MB`;

export const formatRowLimit = (): string => MAX_BULK_DELETE_ROWS.toLocaleString("en-US");
